import {
  getPage,
  getDetail,
  getClientPage,
  datevehicleInfoGroupdurationlimit,
  datedurationlimit,
} from '@/api/timeoutparkinganalysisregulationserv'

export default {
  state: {
    state_TimeoutParkingAnalysisRegulation_GetPageResult: null,
    state_TimeoutParkingAnalysisRegulation_GetDetailResult: null,
    state_TimeoutParkingAnalysisRegulation_GetClientPageResult: null,
    state_TimeoutParkingAnalysisRegulation_DatevehicleInfoGroupdurationlimitResult: null,
    state_TimeoutParkingAnalysisRegulation_DatedurationlimitResult: null,
  },
  mutations: {
    SET_TIMEOUTPARKINGANALYSISREGULATION_GETPAGE_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisRegulation_GetPageResult = rst;
    },
    SET_TIMEOUTPARKINGANALYSISREGULATION_GETDETAIL_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisRegulation_GetDetailResult = rst;
    },
    SET_TIMEOUTPARKINGANALYSISREGULATION_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisRegulation_GetClientPageResult = rst;
    },
    SET_TIMEOUTPARKINGANALYSISREGULATION_DATEVEHICLEINFOGROUPDURATIONLIMIT_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisRegulation_DatevehicleInfoGroupdurationlimitResult = rst;
    },
    SET_TIMEOUTPARKINGANALYSISREGULATION_DATEDURATIONLIMIT_RESULT: (state, rst) => {
      state.state_TimeoutParkingAnalysisRegulation_DatedurationlimitResult = rst;
    },
  },
  actions: {
    TimeoutParkingAnalysisRegulationServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TimeoutParkingAnalysisRegulationServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TimeoutParkingAnalysisRegulationServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TimeoutParkingAnalysisRegulationServ_DatevehicleInfoGroupdurationlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datevehicleInfoGroupdurationlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_DATEVEHICLEINFOGROUPDURATIONLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_DATEVEHICLEINFOGROUPDURATIONLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TimeoutParkingAnalysisRegulationServ_Datedurationlimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datedurationlimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_DATEDURATIONLIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TIMEOUTPARKINGANALYSISREGULATION_DATEDURATIONLIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_TimeoutParkingAnalysisRegulation_GetPageResult: state => {
      return state.state_TimeoutParkingAnalysisRegulation_GetPageResult;
    },
    get_TimeoutParkingAnalysisRegulation_GetDetailResult: state => {
      return state.state_TimeoutParkingAnalysisRegulation_GetDetailResult;
    },
    get_TimeoutParkingAnalysisRegulation_GetClientPageResult: state => {
      return state.state_TimeoutParkingAnalysisRegulation_GetClientPageResult;
    },
    get_TimeoutParkingAnalysisRegulation_DatevehicleInfoGroupdurationlimitResult: state => {
      return state.state_TimeoutParkingAnalysisRegulation_DatevehicleInfoGroupdurationlimitResult;
    },
    get_TimeoutParkingAnalysisRegulation_DatedurationlimitResult: state => {
      return state.state_TimeoutParkingAnalysisRegulation_DatedurationlimitResult;
    },
  }
}